import type { FeatureFlagHistoryActor as GQLItem } from '../../../generated/internal.graphql';

/** The staff user who made a recorded feature-flag change. */
export type FeatureFlagHistoryActor = {
  id: number;
  email: string;
  name: string | null;
};

export const fromGql = (item: GQLItem): FeatureFlagHistoryActor => ({
  id: item.id,
  email: item.email,
  name: item.name ?? null,
});
